import LightBoxGallery from './LightBoxGallery.jsx';
import ReactMarkdown from 'react-markdown';
import { useTranslation } from 'react-i18next';
import {
  generateHappyEndingSlug,
  getHappyEndingOccurrence,
} from '../utils/petSlug';
import { Link } from 'react-router-dom';

function HappyEndingCard({ post, allHappyEndings = [] }) {
  const { i18n } = useTranslation();
  const lang = i18n.language; // "bs" ili "en"

  const months = {
    bs: [
      'Januar',
      'Februar',
      'Mart',
      'April',
      'Maj',
      'Juni',
      'Juli',
      'August',
      'Septembar',
      'Oktobar',
      'Novembar',
      'Decembar',
    ],
    en: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ],
  };

  function formatDate(dateString, lang) {
    const d = new Date(dateString);
    const month = d.getMonth(); // 0-11
    const day = d.getDate();
    const year = d.getFullYear();

    return `${months[lang][month]} ${day}, ${year}`;
  }

  // Dinamično uzmi title i description iz posta
  const title = post[`title_${lang}`] || post.title_en;
  const description = post[`description_${lang}`] || post.description_en;

  return (
    <div className="card blog-card mb-4">
      <div className="post-info border-irregular2 text-muted">
        {' '}
        {formatDate(post.date, lang)}
      </div>

      <LightBoxGallery
        images={post.images}
        title={title}
        showThumbnails={false}
      />

      <div className="card-body">
        <Link
          to={
            i18n.language === 'bs'
              ? `/happyendings/${generateHappyEndingSlug(title, getHappyEndingOccurrence(post, allHappyEndings, lang))}`
              : `/${i18n.language}/happyendings/${generateHappyEndingSlug(title, getHappyEndingOccurrence(post, allHappyEndings, lang))}`
          }
          state={{ post }}
          className="text-decoration-none"
        >
          <h3 className="card-title">{title}</h3>
        </Link>

        <div className="card-text mt-3">
          <ReactMarkdown
            components={{
              a: ({ node, ...props }) => (
                <a {...props} target="_blank" rel="noopener noreferrer" />
              ),
            }}
          >
            {description.split('\n').join('  \n')}
          </ReactMarkdown>
        </div>
      </div>
    </div>
  );
}

export default HappyEndingCard;
